import styled from 'styled-components';
import { colors, typography } from 'modules/common/styles';
import { SortItem } from 'modules/common/styles/sort';
import { dimensions } from 'modules/common/styles';

const unitSpace = `${dimensions.unitSpacing}px`;
const ActionButtons = styled.div`
  display: flex;
  overflow: hidden;
  align-items: center;
  transition: transform 0.3s ease;
  transform: translate(80px);

  * {
    padding: 0;
    margin-left: ${dimensions.unitSpacing}px;

    &:first-child {
      margin-left: 0;
    }
  }
`;

const InlineItems = styled.div`
  display: flex;
  margin-bottom: ${unitSpace};
  align-items: center;
  justify-content: space-between;

  > div {
    margin-right: ${unitSpace};
  }
`;

const SidebarListItem = styled.li`
  position: relative;
  border-bottom: 1px solid ${colors.borderPrimary};
  background: ${props => props.isActive && colors.bgActive};
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  a {
    white-space: normal;
    flex: 1;
    padding: 10px 0 10px 20px;

    &:hover {
      background: none;
    }

    &:focus {
      color: inherit;
      text-decoration: none;
    }
  }

  &:last-child {
    border: none;
  }

  &:hover {
    cursor: pointer;
    background: ${props => !props.isActive && colors.bgLight};

    ${ActionButtons} {
      transform: translate(0px);
    }
  }
`;

const BoardItem = SidebarListItem.extend`
  overflow: hidden;

  > button {
    padding: 10px 15px 10px 20px;

    i {
      color: ${props => props.isDefault && colors.colorCoreYellow};
    }
  }

  a {
    padding: 10px 20px 10px 0;
    margin-left: 0;
    border-left: 0;
  }
`;

const PipelineContainer = styled.div`
  h3 {
    text-transform: uppercase;
    color: ${colors.colorCoreLightGray};
    font-size: ${typography.fontSizeUppercase}px;
    padding: 10px 20px;
    margin: 0;
  }

  ${SortItem} {
    z-index: 100;
    margin-bottom: -1px;
    border: 0;
    border-top: 1px solid ${colors.borderPrimary};
    border-bottom: 1px solid ${colors.borderPrimary};
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const PipelineRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`;

const StageList = styled.div`
  > button {
    margin-top: 10px;
  }

  ${SortItem} {
    padding: 5px 15px;
  }
`;

const StageItemContainer = PipelineRowContainer.extend`
  align-items: center;

  > *:not(button) {
    margin-right: 10px;
  }
`;

export {
  BoardItem,
  PipelineContainer,
  PipelineRowContainer,
  StageList,
  StageItemContainer,
  InlineItems,
  ActionButtons
};



// WEBPACK FOOTER //
// ./src/modules/common/styles/stage.js